import { h } from "@stencil/core";

const DonutChartGroupIcon = (props) => (
    <g
        class="uic-donut-chart__label-datagroup-icon"
        style={{
            textAnchor: props.d.data.textAnchor,
        }}
        transform={`translate(${props.d.labelInterpolator(props.t, 20)})`}
    >
        <use
            href={props.d.data.icon}
            xlinkHref={props.d.data.icon}
            class={props.d.data.cssClass}
            height="24"
            width="24"
            y="-16"
            x={props.d.midangle < Math.PI ? -4 : -20}
        />
    </g>
);

const DonutChartGroupName = (props) => (
    <text
        class="uic-donut-chart__label-datagroup-name"
        style={{
            textAnchor: props.d.data.textAnchor,
        }}
        transform={`translate(${props.d.labelInterpolator(props.t, 20)})`}
    >
        {props.d.data.label}
    </text>
);

export const DonutChartLabel = (props) => (
    <g
        class={{
            "uic-donut-chart__label": true,
            [`uic-donut-chart__label--${props.d.data.key.toLowerCase()}`]: true,
            [props.d.data.cssClass]: true,
        }}
    >
        <polyline
            class="uic-donut-chart__label-polyline"
            points={props.d.polylineInterpolator(props.t)}
        ></polyline>
        <text
            transform={`translate(${props.d.labelInterpolator(props.t, 0)})`}
            class="uic-donut-chart__label-percentage"
            style={{
                textAnchor: props.d.data.textAnchor,
            }}
        >
            {props.percentageFormatter(props.d.data.percentageRounded)}
        </text>
        {props.breakpoint === "medium" ? (
            <DonutChartGroupIcon d={props.d} t={props.t} />
        ) : (
            props.breakpoint === "large" && (
                <DonutChartGroupName d={props.d} t={props.t} />
            )
        )}
    </g>
);
